import { Store } from 'flummox';

const desktopBg = [
  [require('backgrounds/1.jpg'), require('backgrounds/cover-1.jpg')],
  [require('backgrounds/2.jpg'), require('backgrounds/cover-2.jpg')],
  [require('backgrounds/4.jpg'), require('backgrounds/cover-4.jpg')],
  [require('backgrounds/3.jpg'), require('backgrounds/cover-3.jpg')],
  [require('backgrounds/1.jpg'), require('backgrounds/cover-1.jpg')]
];
const desktop404Bg = [
  require('backgrounds/6.jpg'),
  require('backgrounds/6.jpg')
];
const mobileBg = desktopBg;
const mobile404Bg = desktop404Bg;

class AppStateStore extends Store {
  constructor(flux) {
    super();
    const appStateActions = flux.getActions('appState');

    this.register(appStateActions.openMenu, this.handleMenuOpen);
    this.register(appStateActions.closeMenu, this.handleMenuOpen);
    this.register(appStateActions.openCityMenu, this.handleCityMenuOpen);
    this.register(appStateActions.closeCityMenu, this.handleCityMenuOpen);
    this.register(appStateActions.openCityConfirm, this.handleCityConfirmOpen);
    this.register(appStateActions.closeCityConfirm, this.handleCityConfirmOpen);
    this.register(appStateActions.openForm, this.handleFormOpen);
    this.register(appStateActions.closeForm, this.handleFormOpen);

    this.state = {
      is404: false,
      menuIsOpen: false,
      cityMenuIsOpen: false,
      cityConfirmIsOpen: true,
      formIsOpen: false,
      backgrounds: [0, 1, 2, 3, 4]
        .map(i => [desktopBg[i], mobileBg[i]])
        .concat([[desktop404Bg, mobile404Bg]])
    };
  }

  handle404(is404 = false) {
    this.setState({ is404 });
  }

  handleMenuOpen(menuIsOpen) {
    const formIsOpen = this.state.formIsOpen;
    this.setState({ menuIsOpen, formIsOpen });
  }

  handleCityMenuOpen(cityMenuIsOpen) {
    this.setState({ cityMenuIsOpen });
  }

  handleCityConfirmOpen(cityConfirmIsOpen) {
    this.setState({ cityConfirmIsOpen });
  }

  handleFormOpen(formIsOpen) {
    const menuIsOpen = formIsOpen ? false : this.state.menuIsOpen;
    this.setState({ formIsOpen, menuIsOpen });
  }
}

AppStateStore.serialize = state => {
  return JSON.stringify(state);
};

AppStateStore.deserialize = string => {
  return JSON.parse(string);
};

export default AppStateStore;



// WEBPACK FOOTER //
// ./src/stores/AppStateStore.js